// Per-day HARD site locks (employeeId -> hospitalId), shared by the Anesthesiologists tab, the CRNA tab, and the
// Board. Editing a person's site "coin" on either tab writes here; the Board reads it when you run Allocate and
// passes it to /start-allocation, where the Symphony allocator confines that person to that site for the day.
// Stored locally per day (survives refresh), like the other tab annotations.
export const siteLocksKey = (date: string) => `oc-site-locks-${date}`;

export function loadSiteLocks(date: string): Record<string, string> {
  try {
    const raw = localStorage.getItem(siteLocksKey(date));
    // Accept only a plain object map; reject a JSON array (typeof [] === 'object') or any other shape so a
    // corrupt entry falls back to empty locks instead of poisoning employee->site lookups.
    if (raw) { const v = JSON.parse(raw); if (v && typeof v === 'object' && !Array.isArray(v)) return v as Record<string, string>; }
  } catch { /* ignore */ }
  return {};
}

// Set (hospitalId) or clear (null) the lock for one employee; returns the updated map.
export function setSiteLock(date: string, employeeId: string, hospitalId: string | null): Record<string, string> {
  const locks = loadSiteLocks(date);
  if (hospitalId) locks[employeeId] = hospitalId; else delete locks[employeeId];
  try { localStorage.setItem(siteLocksKey(date), JSON.stringify(locks)); } catch { /* ignore */ }
  return locks;
}
